import PaginatedList from "#root/components/paginated-list";
import RemoteCollection from "#root/utility/remote-collection";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import * as z from "zod";
import PageLayout from "./layout";

export const SyndicatedContentProviderListItemSchema = z.object({
  providerCode: z.string(),
});

const providerCollection = new RemoteCollection(
  "/api/account/self/syndicatedContent/provider",
  SyndicatedContentProviderListItemSchema,
  SyndicatedContentProviderListItemSchema,
);

export default function ArticleListPage(): ReactNode {
  return (
    <PageLayout title="Manage Syndicated Content">
      <section>
        <h1>Syndicated Content</h1>
        <p>Manage your syndicated content providers. Select a provider to view and edit its articles.</p>
        <PaginatedList title="Select Feed" collection={providerCollection}>
          {({ rows }) =>
            rows ? (
              <table className="syndicatedContent">
                <thead>
                <tr>
                  <th>Provider Code</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {rows.map(({ providerCode }) => (
                  <tr key={providerCode}>
                    <td>{providerCode}</td>
                    <td>
                      <Link to={providerCode}>Articles</Link>
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            ) : (
              <p>Your account does not support this feature</p>
            )
          }
        </PaginatedList>
      </section>
    </PageLayout>
  );
}
